import * as React from "react";
import { TextField as MaterialTextField, TextFieldProps } from "@mui/material";

const TextField: React.FunctionComponent<TextFieldProps> = React.forwardRef((props: TextFieldProps, ref) =>
    <MaterialTextField ref={ref} size="small" {...props} />
);

export default TextField;